<template>
    <div class="order-history">
        <div class="order-history__header">
            <img class="order-history__header-icon" :src="require('../../assets/history_icon.svg')" alt="Order History">
            <div class="order-history__header-title">Bestelltes Essen</div>
        </div>
        <b-overlay :show="isLoading" rounded="sm">
            <ul class="order-history__list">
                <li
                    :class="getListItemClasses(orderedItem)"
                    v-for="(orderedItem, key) in orderedItems"
                    :key="key"
                >
                    <div class="order-history__list-item-content">
                        <div class="order-history__list-item-content-left">
                            <div class="order-history__list-item-content-title">
                                {{ orderedItem.name }}
                                <img
                                    v-if="orderedItem.is_deposit"
                                    class="ml-1"
                                    :src="require('../../assets/retour_green_icon.svg')"
                                    alt="Positive deposit"
                                >
                            </div>
                            <div
                                class="order-history__list-item-content-title--deposit"
                                v-for="(deposit, index) in orderedItem.deposits"
                                :key="index"
                            >
                                {{ deposit.name }}
                                <img class="ml-1" :src="require('../../assets/recycle.svg')" alt="Negative deposit">
                            </div>
                        </div>
                        <div class="order-history__list-item-content-right">
                            <div class="order-history__list-item-content-right-col">
                                <div class="order-history__list-item-content-price">
                                    {{ orderedItem.quantity }} x {{ orderedItem.price }} €
                                </div>
                                <div
                                    class="order-history__list-item-content-price"
                                    v-for="(deposit, index) in orderedItem.deposits"
                                    :key="index"
                                >
                                    {{ orderedItem.quantity }} x {{ deposit.price }} €
                                </div>
                            </div>
                            <div class="order-history__list-item-content-right-col">
                                <div class="order-history__list-item-content-time">
                                    {{ orderedItem.created_at }}
                                </div>
                                <div
                                    class="order-history__list-item-content-time"
                                    v-for="(deposit, index) in orderedItem.deposits"
                                    :key="index"
                                >
                                    {{ orderedItem.created_at }}
                                </div>
                            </div>
                            <div class="order-history__list-item-content-right-col">
                                <div
                                    v-if="orderedItem.is_return"
                                    class="text-center"
                                >
                                    Zurückgegeben
                                </div>
                                <template v-else>
                                    <template v-if="orderedItem.is_deposit">
                                        <b-icon
                                            :id="'popover-deposit-' + key"
                                            style="color: #3E4462 !important; opacity: 1"
                                            icon="info-circle-fill"
                                            variant="info"
                                        ></b-icon>
                                        <b-popover
                                            :target="'popover-deposit-' + key"
                                            triggers="hover click blur"
                                            placement="bottom"
                                        >
                                            Ein Pfand-Artikel! Kann nicht getrennt vom beigefügten Artikel zur Erstattung in
                                            den
                                            Warenkorb gelegt werden
                                        </b-popover>
                                    </template>
                                    <b-button
                                        v-else
                                        class="w-100"
                                        variant="primary"
                                        :disabled="isReturnBtnDisabled(orderedItem)"
                                        @click="returnItem(orderedItem)"
                                    >
                                        Rückgabe
                                    </b-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="order-history__pagination">
                <b-button
                    class="mr-4"
                    variant="outline-secondary"
                    :disabled="isPreviousBtnDisabled"
                    @click="previousPage"
                >Vorherige
                </b-button>
                <b-button
                    variant="outline-secondary"
                    :disabled="isNextBtnDisabled"
                    @click="nextPage"
                >Nächste
                </b-button>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {getCateringOrderItemsHistory} from "@/api/kiosk";
import {mapGetters}                   from "vuex";

export default {
    name:     "OrderHistory",
    props:    {
        returnItemsCart: Array,
    },
    computed: {
        ...mapGetters(['selectedKioskConsumer']),
        isPreviousBtnDisabled() {
            return this.currentPage === 1;
        },
        isNextBtnDisabled() {
            return this.currentPage === this.totalPages;
        },
    },
    data() {
        return {
            isLoading:    false,
            orderedItems: [],
            currentPage:  1,
            totalPages:   null,
        }
    },
    methods: {
        isReturnBtnDisabled(orderedItem) {
            return orderedItem.returnable_quantity === 0 || this.isReturnItemsCartIncludesItem(orderedItem);
        },
        isReturnItemsCartIncludesItem(orderedItem) {
            return !!this.returnItemsCart.find(function (item) {
                return item.id === orderedItem.id;
            })
        },
        getListItemClasses(item) {
            return [
                'order-history__list-item',
                {
                    'order-history__list-item--deposit': item.is_deposit,
                    'order-history__list-item--return':  item.is_return
                }
            ]
        },
        async previousPage() {
            if (this.currentPage === 1) return;

            await this.loadOrderHistory(this.currentPage - 1);
        },
        async nextPage() {
            if (this.currentPage === this.totalPages) return;

            await this.loadOrderHistory(this.currentPage + 1);
        },
        async loadOrderHistory(page = 1) {
            this.isLoading = true;

            const params      = {
                consumer_id: this.selectedKioskConsumer.consumer_id,
                page:        page,
            };
            const response    = await getCateringOrderItemsHistory(params);
            this.orderedItems = response['data']['data'];
            this.currentPage  = response['data']['pagination']['current_page'];
            this.totalPages   = response['data']['pagination']['total_pages'];

            this.isLoading = false;
        },
        returnItem(orderedItem) {
            this.$emit('return', orderedItem);
        },
    },
    async mounted() {
        await this.loadOrderHistory();
    }
}
</script>

<style lang="scss">
@import "../../assets/styles/custom_theme";

.order-history {
    &__header {
        display: flex;
        align-items: center;

        &-icon {
            margin-right: 8px;

            &:hover {
                cursor: pointer;
            }
        }

        &-title {
            font-size: 20px;
            font-weight: 600;
            color: #000000;
        }
    }

    &__list {
        padding-top: 20px;
        padding-inline-start: 10px;

        &-item {
            margin-bottom: 20px;
            list-style-type: none;

            &--deposit {
                .order-history__list-item-content-left,
                .order-history__list-item-content-right-col:not(:last-child) {
                    opacity: .5;
                }
            }

            &--return {
                opacity: .5;
            }

            &-content {
                display: flex;
                align-items: center;

                &:not(:last-child) {
                    margin-bottom: 25px;
                }

                &-left {
                    flex: 0 0 50%;
                }

                &-right {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex: 1 1 auto;

                    &-col {
                        flex: 0 0 33.33%;

                        &:first-child {
                            text-align: right;
                        }

                        &:nth-child(2) {
                            text-align: center;
                        }
                    }
                }

                &-title {
                    &--deposit {
                        font-size: 13px;
                    }
                }

                &-price {
                    font-weight: 600;
                }

                &-time {
                    font-weight: 300;
                }
            }
        }
    }

    &__pagination {
        margin-top: 40px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>